/** Серия и задания дня в состоянии игрока. */
import { Coins, PosInt, UInt, UnixMs } from "../../common";
import { z } from "zod";

/** Ежедневная серия. */
export const StreakState = z.object({
  /** День серии, который можно забрать сегодня (или уже забран), 1…7. */
  day: z.number().int().min(1).max(7),
  claimedToday: z.boolean(),
  /** Монеты за сегодняшний день. */
  todayReward: Coins,
  /** Когда сгорит серия, если не зайти. */
  expiresAt: UnixMs,
});
export type StreakState = z.infer<typeof StreakState>;

/** Задание дня. */
export const DailyTaskId = z.enum(["kills", "waves", "upgrades"]);
export type DailyTaskId = z.infer<typeof DailyTaskId>;

/** Что можно забрать в окне заданий: награду задания или мешок за все три. */
export const DailyTaskClaim = z.enum([...DailyTaskId.options, "bonus"]);
export type DailyTaskClaim = z.infer<typeof DailyTaskClaim>;

/** Задание на сегодня. */
export const DailyTask = z.object({
  id: DailyTaskId,
  target: PosInt,
  /** Сделано, не больше `target`. */
  progress: UInt,
  coins: Coins,
  claimed: z.boolean(),
});
export type DailyTask = z.infer<typeof DailyTask>;

/** Задания дня: считает сервер по принятым журналам волн и покупкам. */
export const DailyTasksState = z.object({
  tasks: z.array(DailyTask).length(3),
  /** Мешок за все три задания. */
  bonus: z.object({ coins: Coins, claimed: z.boolean() }),
  /** Новые задания: в то же время, что и новый день серии. */
  resetsAt: UnixMs,
});
export type DailyTasksState = z.infer<typeof DailyTasksState>;

/** Поля {@link PlayerState}. */
export const progressFields = {
  /** Задания дня; `null` — в данных баланса заданий нет. Без поля (старый сервер во время выката) — тоже `null`. */
  tasks: DailyTasksState.nullable().default(null),
};
